import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const datePickerTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      // Legacy properties for datetime-picker-style
      calendarBG: theme.color.surface[1],
      label: theme.color.text.core['-primary'],
      cell: theme.color.surface[2],
      cellSelected: theme.color.focus[3],
      textInactive: theme.color.text.core['-secondary'],
      textActive: theme.color.text.core['-primary'],
      cellSelectedBorder: theme.color.focus[2],
      cellBorder: theme.color.surface[4],
      error: theme.color.dataVis.core['critical-1'],
      // Modal styles
      modalOverlay: 'rgba(0, 0, 0, 0.5)',
      modalContainer: {
        background: theme.color.surface[1],
        borderRadius: '8px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      },
      modalHeader: {
        borderBottom: theme.color.surface[4],
      },
      modalTitle: {
        color: theme.color.text.core['-tertiary'],
      },
      modalCloseButton: {
        color: theme.color.text.core['-secondary'],
        hoverBackground: theme.color.surface[2],
      },
      modalFooter: {
        borderTop: theme.color.surface[4],
        background: theme.color.surface.cool[2],
      },

      // Left panel - Preset list
      leftPanel: {
        borderRight: theme.color.surface[4],
        background: theme.color.surface[1],
      },
      presetItem: {
        selected: {
          background: theme.color.grid.select,
          color: theme.color.text.core['-primary'],
        },
        default: {
          background: theme.color.grid.base,
          color: theme.color.text.core['-primary'],
          hoverBackground: theme.color.surface[2],
        },
      },
      month: {
        selected: {
          background: theme.color.focus[3],
          color: theme.color.text.core['on-dark-primary'],
        },
        default: {
          background: 'transparent',
          color: theme.color.text.core['-primary'],
        },
        separator: {
          borderColor: theme.color.surface[2],
        },
      },
      timePicker: {
        selected: {
          background: theme.color.focus[3],
          color: theme.color.text.core['on-dark-primary'],
        },
        default: {
          background: 'transparent',
          color: theme.color.text.core['-primary'],
          hoverBackground: theme.color.surface[2],
        },
      },
      presetCheck: {
        color: theme.color.focus[3],
      },
      presetDefault: {
        color: theme.color.text.core['-secondary'],
        background: theme.color.surface[3],
      },
      presetSearch: {
        borderBottom: theme.color.surface[4],
      },

      // Right panel
      rightPanelHeader: {
        marginBottom: '24px',
      },
      dateRangeDisplay: {
        color: theme.color.text.core['-secondary'],
      },

      // Tabs
      tabContainer: {
        borderBottom: theme.color.surface[4],
      },
      tabButton: {
        active: {
          color: theme.color.text.core['-emphasis'],
          borderBottom: theme.color.focus[2],
        },
        default: {
          color: theme.color.text.core['-secondary'],
          borderBottom: 'transparent',
        },
        hover: {
          color: theme.color.text.core['-emphasis'],
        },
      },

      // Time input styles
      timeInputLabel: {
        color: theme.color.text.core['-secondary'],
      },
      timeInputField: {
        border: theme.color.surface[4],
        focusBorder: theme.color.focus[3],
        focusShadow: `${theme.color.focus[3]}1a`,
      },

      // Timezone selector styles
      timezoneSearchInput: {
        border: theme.color.surface[4],
      },
      timezoneItem: {
        selected: {
          background: theme.color.focus[1],
          color: theme.color.text.core['on-dark-primary'],
        },
        hover: {
          background: theme.color.surface[2],
        },
      },
      timezoneOffset: {
        color: theme.color.text.core['-secondary'],
      },

      // Calendar styles
      quickRangeButton: {
        border: theme.color.surface[4],
        background: theme.color.surface[0],
        hoverBackground: theme.color.surface[2],
        hoverBorder: theme.color.surface[5],
      },
      monthButton: {
        border: theme.color.surface[4],
        hoverBackground: theme.color.surface[2],
        hoverBorder: theme.color.surface[5],
        color: theme.color.text.core['-primary'],
      },
      monthLabel: {
        color: theme.color.text.core['-primary'],
      },
      dayLabel: {
        color: theme.color.text.core['-secondary'],
        background: theme.color.surface[1],
      },
      dayCell: {
        disabled: {
          background: theme.color.surface[2],
          color: theme.color.text.core['-secondary'],
        },
        otherMonth: {
          background: 'transparent',
          color: theme.color.text.core['-secondary'],
        },
        startEnd: {
          background: theme.color.focus[3],
          color: theme.color.text.core['on-dark-primary'],
          border: theme.color.focus[1],
        },
        inRange: {
          background: theme.color.focus[6],
          color: theme.color.text.core['-primary'],
          border: theme.color.focus[4],
        },
        hoverRange: {
          background: theme.color.focus[6],
          color: theme.color.text.core['-primary'],
          border: theme.color.focus[4],
        },
        default: {
          background: 'transparent',
          color: theme.color.text.core['-primary'],
          hoverBackground: theme.color.surface[2],
        },
      },

      // Time picker layout
      timePickerLayout: {
        borderBottom: theme.color.surface[4],
      },
      timezoneLabel: {
        color: theme.color.text.core['-secondary'],
      },
    },
  ]),
);
